import React from 'react'
import useSessionStatusData from '../../hooks/useSessionStatusData'

import ScrollableTable from '../common/ScrollableTable'
import CloningStatusLabel from '../status/CloningStatusLabel'
import ClonedLeagueLink from './ClonedLeagueLink'
import { JobStatusEnum } from '../../constants'

const headers = [ 'Event/League Name', 'Status' ]

const transformJobsData = (polledJobsList) => {
  if (!polledJobsList) {
    return []
  }

  return polledJobsList.map((job) => [
    <ClonedLeagueLink
      key={`link-${job.id}`}
      label={job?.parameters?.league_name}
      path={job?.job?.status === JobStatusEnum.COMPLETED ? job?.league_path : null}
    />,
    <CloningStatusLabel key={`status-${job.id}`} status={job?.job?.status} />,
  ])
}

const SessionStatusTable = () => {
  const { polledJobsList } = useSessionStatusData()

  return (
    <ScrollableTable
      headers={headers}
      data={transformJobsData(polledJobsList)}
      keyExtractor={(_, index) => polledJobsList?.[index]?.id ?? index}
      withIndex
    />
  )
}

export default SessionStatusTable
